/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind.js';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { getId } from './dragAndDropHelper';
import styles from './drag-and-drop.module.scss';

const cx = classNames.bind(styles);
export function DragItem({
  dragOverlay,
  id,
  groupId,
  index: podIndex,
  renderItem,
  userSelect
}) {
  const item = getId(id);
  const {
    setNodeRef,
    isDragging,
    transform,
    transition,
  } = useSortable({
    id,
    data: { groupId, item }
  });
  const transformTransitionStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    '--index': podIndex,
    WebkitTransform: 'translateZ(0)',
    WebkitUserSelect: userSelect,
    msUserSelect: userSelect,
    userSelect
  };

  const SortableCssClasses = cx(
    styles.Sortable, {
      [styles.dragOverlay]: dragOverlay
    }
  );
  const ItemCssClasses = cx(
    styles.Item, {
      [styles.dragging]: isDragging,
      [styles.dragOverlay]: dragOverlay,
    }
  );

  return (
    <div
      data-testid="draggable-item"
      ref={setNodeRef}
      className={SortableCssClasses}
      style={transformTransitionStyle}
    >
      <div className={ItemCssClasses}>
        {
          renderItem({
            setNodeRef, isDragging, id, item, groupId
          })
        }
      </div>
    </div>
  );
}

DragItem.displayName = 'DragItem';

DragItem.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  renderItem: PropTypes.func.isRequired,
  groupId: PropTypes.string,
  dragOverlay: PropTypes.bool,
  userSelect: PropTypes.string
};

DragItem.defaultProps = {
  dragOverlay: false,
  groupId: null,
  userSelect: 'none'
};
